export const requisitesAndContacts = {
    companyName: "UAB OPAY solutions",
    companyCode: "302664558",
    bankAccountNumber: "LT047300010128146199",
    bankName: "AB „Swedbank”",
    bankCode: "73000",
    workingHours: "I - V 9:00 - 18:00",
    phone: "+370 611 55554"
}
